module.exports = __webpack_public_path__ + "assets/img/is-favorite-not.0cfc2036.svg";